import { useState, useEffect } from "react";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import enUS from "date-fns/locale/en-US";
import './notificationDetails.css'

const DateRangePicker = ({ startDate, endDate, onChange, onClose }) => {
    const [range, setRange] = useState([
        {
            startDate: startDate || new Date(),
            endDate: endDate || new Date(),
            key: "selection",
        },
    ]);

    useEffect(() => {
        setRange([
            {
                startDate,
                endDate,
                key: "selection",
            }
        ]);
    }, [startDate, endDate]);

    const handleSelect = (item) => {
        setRange([item.selection]);
    };

    const handleSet = () => {
        onChange(range[0]);
        onClose();
    };

    return (
        <div className="calendar-popup">
            <div className="calendar-wrapper">
                <DateRange
                    editableDateInputs={true}
                    onChange={handleSelect}
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    months={2}
                    direction="horizontal"
                    showMonthAndYearPickers={true}
                    rangeColors={["#f25c2a"]}
                    locale={enUS}
                />



                <div className="calendar-actions">
                    {/* <div className="date-inputs-wrapper" >
                        <input
                            className="candidatecal-date-input"
                            value={format(range[0].startDate, "dd/MM/yyyy")}
                            readOnly
                        />
                        <span className="arrow"> → </span>
                        <input
                            className="candidatecal-date-input"
                            value={format(range[0].endDate, "dd/MM/yyyy")}
                            readOnly
                        />
                    </div> */}
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="set-btn" onClick={handleSet}>Set Date</button>
                </div>
            </div>
        </div>
    );
};

export default DateRangePicker;